<div class="modal-wrap">
  <div class="top">
    <h1>푸시알림 전송</h1>
    <p class="right">필수 <span>*</span></p>
    <p class="sub">알림 제목 <span>*</span></p>
    <input [(ngModel)]="title" name="" id="" cols="30" rows="10" placeholder="알림 제목을 입력해주세요." />
    <p class="sub mt-4">알림 내용 <span>*</span></p>
    <textarea [(ngModel)]="text" name="" id="" cols="30" rows="10" placeholder="알림 내용을 입력해주세요."></textarea>
  </div>

  <div class="btn-wrap">
    <button (click)="modalService.dismissAll()" type="button" class="btn btn-outline-light mr-2">닫기</button>
    <button (click)="sendPush()" [disabled]="!text.trim() || !title.trim()" type="button" class="btn btn-primary">전송하기</button>
  </div>
</div>
